module.exports = __webpack_public_path__ + "static/media/9.5f9e0c33.jpg";